import { useEffect, useState } from 'react';

export const useCustomization = ({ data, onCompleteCustomization }) => {
	const totalSteps = 3;
	const [skipped, setSkipped] = useState(false);
	const [step, setStep] = useState(0);
	const [selection, setSelection] = useState(() => {
		return [
			{ value: data.options[0].goal_id, label: data.options[0].goal_name },
			{ value: data.options[0].roles[0].role_id, label: data.options[0].roles[0].role_name },
		];
	});
	const [customizationOptions, setCustomizationOptions] = useState([]);

	// Initialize customization options based on the current step
	useEffect(() => {
		if (0 === step) {
			setCustomizationOptions(() =>
				data.options.reduce((acc, option) => {
					acc.push({
						id: option.goal_id,
						name: option.goal_name,
					});
					return acc;
				}, []),
			);
		} else {
			setCustomizationOptions(() => {
				const goalData = data.options.find((option) => option.goal_id === selection[0].value);
				return goalData.roles.reduce((acc, role) => {
					acc.push({
						id: role.role_id,
						name: role.role_name,
					});
					return acc;
				}, []);
			});
		}
	}, [step]);

	const onChangeOption = (e) => {
		const { value } = e.target;
		const newSelection = [...selection];

		let selectionLabel = '';
		if (value !== 'custom') {
			selectionLabel = customizationOptions.find((option) => option.id === value)?.name || '';
		}

		newSelection[step] = { value, label: selectionLabel };

		// If on the first step, reset the second step selection
		if (step === 0) {
			const goal = data.options.find((option) => option.goal_id === value);
			newSelection[1] = {
				value: goal.roles[0].role_id,
				label: goal.roles[0].role_name,
			};
		}

		setSelection(newSelection);
	};

	const onCustomInputChange = (e) => {
		const { value } = e.target;
		const newSelection = [...selection];
		newSelection[step].label = value;
		setSelection(newSelection);
	};

	const goToNextStep = () => {
		setStep((prevStep) => prevStep + 1);
	};

	const goToPreviousStep = () => {
		setSkipped(false);
		setStep((prevStep) => Math.max(prevStep - 1, 0));
	};

	const goToFirstStep = () => {
		setSkipped(false);
		setStep(0);
	};

	const finishCustomization = () => {
		let trialTemplate = data.default_trial_template;
		if (!skipped) {
			trialTemplate = data.options.find((option) => option.goal_id === selection[0].value).trial_template;
		}
		onCompleteCustomization({ selection, skipped, trialTemplate });
	};

	const skipCustomization = () => {
		setStep(totalSteps - 1);
		setSkipped(true);
	};

	return {
		customizationOptions,
		finishCustomization,
		goToFirstStep,
		goToNextStep,
		goToPreviousStep,
		onChangeOption,
		onCustomInputChange,
		selection,
		skipCustomization,
		step,
		totalSteps,
	};
};
